import { useSearchParams } from 'react-router';

import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import {
  ANY_SPORT_MARKET,
  FOOTBALL_MARKET_NEW_SEASON,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';
import { navLabels } from '@sorare/core/src/lib/glossary';

import { IosHeader } from '#src/components/market/IosHeader/index.tsx';
import { FROM_NEW_SEASON_PARAM } from '#src/lib/newSeason.tsx';

export const MarketShopHeader = () => {
  const { generateSportContextPath } = useSportContext();
  const { isIosApp } = useIsMobileApp();
  const [searchParams] = useSearchParams();

  const fromNewSeason = searchParams.has(FROM_NEW_SEASON_PARAM);
  const backTo = fromNewSeason
    ? FOOTBALL_MARKET_NEW_SEASON
    : generateSportContextPath(ANY_SPORT_MARKET);

  if (isIosApp) {
    return <IosHeader to={backTo} text={navLabels.shop} />;
  }
  return (
    <PageHeader
      text={navLabels.shop}
      backTo={backTo}
      disableBackBrowser={!fromNewSeason}
    />
  );
};
